import React from 'react';
import Button from '../../../shared/button.component';

type AdminOptionWrapperProps = { label: string, children: React.ReactNode };

export const AdminOptionWrapper = ({ label, children }: AdminOptionWrapperProps) => (
  <div className="admin-option-wrapper row no-gutters page-content-container">
    <div className="col">
      <div className="form-group row align-items-center">
        <label className="col-3 col-form-label">{label}</label>
        <div className="admin-option-content form-control-container col-9">
          {children}
        </div>
        <hr />
      </div>
    </div>
  </div>
);

type AdminOptionProps = {
  label: string,
  buttonLabel: string,
  isLoading: boolean,
  disabled?: boolean,
  onClick: (...args: any[]) => any,
}

export const AdminOption = ({
  label,
  buttonLabel,
  isLoading,
  disabled = false,
  onClick,
}: AdminOptionProps) => (
  <AdminOptionWrapper label={label}>
    <Button
      type="button"
      kind="primary"
      onClick={onClick}
      disabled={disabled}
      isLoading={isLoading}
    >
      {buttonLabel}
    </Button>
  </AdminOptionWrapper>
);
